import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tears': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M102.4 256.1c5.6-0.8 10.3 3.9 9.5 9.4-3.3 22.6-12 73.5-26.8 88.3-19.2 19.2-50.6 18.9-70.2-0.7-19.6-19.6-19.9-51.1-0.8-70.2 14.8-14.8 65.7-23.6 88.3-26.8zM625.8 282.9c19.2 19.1 18.8 50.7-0.8 70.3-19.6 19.6-51 19.9-70.2 0.7-14.8-14.8-23.6-65.7-26.8-88.3-0.8-5.6 4-10.3 9.5-9.5 22.6 3.3 73.5 12 88.3 26.8zM496.4 270.1c11.8 82.3 29.9 100.4 35.8 106.3 0.9 1 2 1.6 3 2.5-42.7 74.7-123 125.1-215.2 125.1s-172.5-50.4-215.2-125c1-0.9 2.1-1.6 3-2.5 5.9-6 24-24.1 35.8-106.4 2.9-20.4-12.5-49.6-45.7-45.7-8.9 1.3-16.8 2.7-24.3 4.1 13.7-124 118.7-220.5 246.4-220.5s232.7 96.5 246.4 220.5c-7.5-1.4-15.4-2.8-24.3-4.1-26.6-3.8-49.5 19.1-45.7 45.7zM400 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.7 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.5 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM240 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.7 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.5 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM320 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.3-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.5-3.7-22.7 6.2-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tears.js
// module id = 1406
// module chunks = 0